import type { IEmbedSize } from "~/feature/embed/utils/getEmbedMinSize";

// Whichever dimension runs out of room first decides the scale — fitting only
// the width would let a tall embed grow the dialog instead of shrinking.
export const getFitScale = (
  content: IEmbedSize,
  availableWidth: number | null,
  availableHeight: number
): number => {
  if (!availableWidth || !content.width || !content.height) {
    return 1;
  }

  return Math.min(
    1,
    availableWidth / content.width,
    availableHeight / content.height
  );
};
